import { render, staticRenderFns } from "./VeJwCjPutinWrite.vue?vue&type=template&id=5c8c576c"
import script from "./VeJwCjPutinWrite.vue?vue&type=script&lang=js"
export * from "./VeJwCjPutinWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports